import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setTableCancellationDetailsItem } from '../../../redux/action/tableCart'
import { CancellationDetailsModalBtnWrapper, CancellationDetailsModalWrapper, ItemWrapper, Text, TextSubTitle } from './index.styled'
import CustomModal from '../../Elements/modal/CustomModal'
import Button from '../../Elements/buttons/Button'
import { selectItemCancellationMetaData } from '../../../redux/selector/restaurant'
import { getNeededDateFormat } from '../../../helper'

const EVENT_Z_INDEX = 122

const CancellationDetailsModal = React.memo(() => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const cancellationDetailsItem = useSelector(state => state.tableCart.cancellationDetailsItem)
	const dataItem = useSelector(selectItemCancellationMetaData)
	const reason = dataItem?.reasonType === 'OTHER' ? dataItem?.reason : t(`Cart.CancelReasonModal.${dataItem?.reasonType}`)
	const date = dataItem?.dateTime ? getNeededDateFormat(dataItem?.dateTime, 'dd.MM.y, HH:mm') : '--------'
	const userName = dataItem?.userName || '--------'

	const handleClose = useCallback(() => {
		dispatch(setTableCancellationDetailsItem(null))
	}, [dispatch])

	return (
		<CustomModal isOpen={cancellationDetailsItem}
								 close={handleClose}
								 size="small"
								 returnZIndex={0}
								 zIndex={EVENT_Z_INDEX}
								 disableBackButton={true}
								 title={t('restaurant.tables.cancellationDetails.title')}>

			<CancellationDetailsModalWrapper>
				<ItemWrapper>
					<TextSubTitle>{t('restaurant.tables.cancellationDetails.reason')}:</TextSubTitle>
					<Text>{reason}</Text>
				</ItemWrapper>
				<ItemWrapper>
					<TextSubTitle>{t('restaurant.tables.cancellationDetails.appliedBy')}:</TextSubTitle>
					<Text>{userName}</Text>
				</ItemWrapper>
				<ItemWrapper>
					<TextSubTitle>{t('restaurant.tables.cancellationDetails.date')}:</TextSubTitle>
					<Text>{date}</Text>
				</ItemWrapper>
				<CancellationDetailsModalBtnWrapper>
					<Button name="accept" icon="checkmark" onClick={handleClose} tabIndex="1" text="Ok" color="green" keyButton="F2" zIndex={EVENT_Z_INDEX} />
				</CancellationDetailsModalBtnWrapper>
			</CancellationDetailsModalWrapper>
		</CustomModal>
	)
})
CancellationDetailsModal.displayName = 'CancellationDetailsModal'
export default CancellationDetailsModal
